import React from "react";
import AboutComponent from "../components/about/about";

function AboutusPage() {
  return (
    <>
      <AboutComponent>
        <div className="content-img">
          <img src={"assets/img/about-img.png"} />
        </div>
        <p>
          AM-PM Engineering, an&nbsp;Indian&nbsp;company,&nbsp;is a global
          trader &amp; manufacturer of&nbsp;engineered
          Industrial&nbsp;components.
        </p>

        <p>
          Our management acquired its roots in the marketplace for over forty
          years through trading&nbsp;of the finest quality of industrial &amp;
          hardware products. With our roots firmly planted, AM-PM Engineering
          has expanded its business in the&nbsp;manufacturing sector of
          industrial Products.&nbsp;Every organization we work with benefits
          from over 40 years of experience, innovation, and techniques that have
          redefined the manufacturing industry which consistently delivers value
          through our engineering expertise, efficient operations, and
          Systematic Quality Planning systems.
        </p>

        <p>
          With&nbsp;a proper mix of talent &amp; experience in this field, AM-PM
          Engineering has a dedicated team with technical expertise, that
          provides best possible Product services to our customer in&nbsp;given
          time.
        </p>

        <p>
          AM-PM Engineering is registered export house from INDIA. AM-PM
          engineering partners with customers for sustainable, mutual growth.
        </p>
        <p>
          Our commitment to continuous improvement through the addition of
          innovative new products to our range, and the on-going development of
          our people, will ensure the success of our business into the future.
        </p>
        <p>QUALITY&nbsp;ASSURANCE:-</p>

        <p>
          We&nbsp;have&nbsp;always&nbsp;believed&nbsp;that&nbsp;“ People can buy
          a Product easily, but not a Quality&nbsp;Product. It’s
          a&nbsp;“PROFESSION OF PRECISION”
        </p>

        <p>
          AM-PM&nbsp;Engineering&nbsp;strongly focuses on Quality aspects
          while&nbsp;Manufacturing. We never compromise Quality of the Product
          at the time of RFQ’s.
        </p>

        <p>Stringent quality Procedures are followed :-</p>

        <p>
          1)Before starting Production, Process Flow chart &amp; Checklist is
          prepared, same is shared to customer to ensure we both are on the same
          page.
        </p>

        <p>
          2)In-process Inspection reports are maintained every 1 hr, to
          keep&nbsp;consistency with&nbsp;quality.
        </p>

        <p>
          3)Every shipment detail Product inspection report is sent, this helps
          in Traceability.
        </p>

        <p>
          4)Control Plan for every Product is maintained &amp; shared at time of
          delivery of parts to help customer identify the&nbsp;detailed
          information, and the manufacturing process we have followed.
        </p>

        <p>
          5)We are capable to manufacture parts within tolerance limit of +/-
          0.05mm.
        </p>

        <p>
          6)Every New Product developed is sent to customer for Final approval
          before starting the Production.
        </p>

        <p>
          7)Quality&nbsp;Standards are
          followed&nbsp;exactly&nbsp;as&nbsp;per&nbsp;customer requirements.
        </p>

        <p>
          ON IS TO PROVIDE BEST SOLUTION THAT HELPS EVERYONE. IF YOU WANT TO
          CONTACT US, PLEASE FILL THE CONTACT FORM ON OUR WEBSITE. WE WISH YOU
          A...
        </p>
      </AboutComponent>
    </>
  );
}

export default AboutusPage;
